<template>
    <div>
        <div class="modal-mask">
        </div>
        <div class="screen">
            <div class="modal-content">
                <button class="btn_close">
                    <img
                        src="@/assets/images/close_icon.jpg"
                        alt="닫기"
                        tabindex="1"
                        @click="$emit('closePopup')"
                    />
                </button>

                <div class="popup-title">
                    프리미엄 리포트
                </div>
                <div class="desc">
                    <p>Selvy Checkup 앱으로 좀 더 자세하고 정확한 건강분석 리포트를 받아 보세요.</p>
                </div>
                <div class="sample">
                    <img
                        src="@/assets/images/img-report-sample.png"
                        class="sample-img"
                        alt="샘플"
                    >
                    <br/>
                    10개 질환 별 분석<br/>
                    건강검진 내역 관리<br/>
                    건강 나이, 기대 생존율 확인<br/>
                </div>
                <button class="btn primaries" @click="launchApp()" tabindex="2">
                    Selvy Checkup 앱 열기 >
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            isOrange: {
                type: Boolean,
                default: false
            },
            code: {
                type: String,
                default: ''
            }
        },
        data () {
            return {
            }
        },
        computed: {
        },
        methods: {
            launchApp () {
                const siteCode = sessionStorage.getItem('siteCode') || ''
                if (siteCode.length > 0) {
                    if (process.env.NODE_ENV === 'development') {
                        return window.open(`http://manager-dev.selvy.ai/f/${siteCode}`)
                    }
                    return window.open(`https://manager.selvy.ai/f/${siteCode}`)
                }

                window.open('https://links.selvy.ai/app')
            }
        }
    }
</script>

<style scoped lang="scss">
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #212121;
        opacity: 0.7;
        overflow-y: scroll;
    }
    .screen {
        z-index: 9999;
        position: fixed;
        top: 0px;
        left: 0px;
        height: 100vh;
        width: 100vw;
        text-align: center;
        line-height: 100vh;
        vertical-align: middle;
        overflow: scroll  ;
    }
    .modal-content {
        position: relative;
        display: inline-block;
        background-color: white;
        width: 90vw;
        // max-width: 500px;
        padding: 7vmin;
        text-align: center;
        font-family: "SpoqaHanSans", sans-serif;
        line-height: 140%;
        vertical-align: middle;
    }
    .btn_close {
        text-align: right;
        img {
            margin-left: auto;
        }
    }
    .popup-title {
        font-weight: bold;
        font-size: 3vh;
        margin-bottom: 1vh;
    }
    .desc {
        color: #202020;
        font-size: 2vh;
        word-break: keep-all;
        margin-bottom: 4vh;
    }
    .sample {
        color: #202020;
        font-size: 1.8vh;
        margin-bottom: 3vh;
    }
    .sample-img {
        width: 50vmin;
        margin-bottom: 18px;
    }
    .btn.primaries {
        position: relative;
        right: auto;
        background-color: #3f6fff;
        color: white;
        font-size: 2vh;
        font-weight: bold;
        width: 100%;
        height: 5vh;
        border-radius: 2.5vh;
        vertical-align: middle;
        line-height: 4vh;
        box-shadow: 0 8px 2vh -4px rgba(63, 111, 255, 0.5);
        margin-bottom: 2vh;
    }
</style>
